/**
 * TanStack Query hooks for `metrics-cpc-cpa-epc-avg-sale-cr-roi-roas-revenue-payout-profit`.
 * Thin wrappers over ./api.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import {
	get,
	getBreakdown,
	metricsCpcCpaEpcAvgSaleCrRoiRoasRevenuePayoutProfitQueryKeys,
	type MetricKey,
	type MetricsBreakdown,
	type MetricsQueryParams,
	type MetricsResponse,
} from "./api";

export function useMetricsCpcCpaEpcAvgSaleCrRoiRoasRevenuePayoutProfitList(
	params: MetricsQueryParams,
): UseQueryResult<MetricsResponse, Error> {
	return useQuery({
		queryKey: metricsCpcCpaEpcAvgSaleCrRoiRoasRevenuePayoutProfitQueryKeys.list(params),
		queryFn: () => get(params),
		staleTime: 25_000,
		refetchInterval: 30_000,
		refetchOnWindowFocus: false,
	});
}

export function useMetricsCpcCpaEpcAvgSaleCrRoiRoasRevenuePayoutProfitBreakdown(
	metric: MetricKey | null,
	params: Omit<MetricsQueryParams, "metric">,
): UseQueryResult<MetricsBreakdown, Error> {
	return useQuery({
		queryKey:
			metric !== null
				? metricsCpcCpaEpcAvgSaleCrRoiRoasRevenuePayoutProfitQueryKeys.detail(metric, params)
				: [...metricsCpcCpaEpcAvgSaleCrRoiRoasRevenuePayoutProfitQueryKeys.all, "breakdown", "idle"],
		queryFn: () => {
			if (!metric) throw new Error("metric required");
			return getBreakdown(metric, params);
		},
		enabled: metric !== null,
		staleTime: 25_000,
	});
}
